import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { GlobalState } from '@/store/modules/global/types';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} as Module<GlobalState, RootState>;
